import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import CardGatewayDetailViewModel from "viewModels/finance/outgoingPayments/cardGatewayDetailViewModel";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import Col from "react-bootstrap/Col";
import { NavigationFooter } from "../../../common/navigationFooter";
import RefundChargeSection from "../refundChargeSection";
import { Modal, Row } from "react-bootstrap";
import OutgoingPayGatePaymentSection from "./outgoingPayGatePaymentSection";

const CardGatewayDetailView: ViewComponent<CardGatewayDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal scrollable show={true} onHide={vm.requestClose} centered dialogClassName="modal-90w">
      <Modal.Header closeButton={true}>
        <div className="d-flex justify-content-start align-items-center">
          <h3 className="mb-0">{vm.translate("outgoingPaymentTitle")}</h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {!vm.isInitialized || !vm.item ? (
            <div style={{ minHeight: "100px" }} />
          ) : (
            <Row>
              <Col lg={12} xl={5}>
                <RefundChargeSection vm={vm} />
              </Col>
              <Col lg={12} xl={7}>
                <OutgoingPayGatePaymentSection vm={vm} />
              </Col>
            </Row>
          )}
        </LoaderOverlay>
      </Modal.Body>
      <Modal.Footer style={{ minHeight: "100px" }}>
        <NavigationFooter vm={vm} />
      </Modal.Footer>
    </Modal>
  );
});

registerView(CardGatewayDetailView, CardGatewayDetailViewModel);
